import { Player, PlayerPosition } from './types';

// Seat configuration object - can be edited manually to align with table image
export const SEAT_POSITIONS: {
   [key: string]: { x: number; y: number };
} = {
   'USER': { x: 395, y: 442 },
   'seat1': { x: 199, y: 439 },
   'seat2': { x: 38, y: 338 },
   'seat3': { x: 56, y: 152 },
   'seat4': { x: 207, y: 75 },
   'seat5': { x: 543, y: 74 },
   'seat6': { x: 699, y: 144 },
   'seat7': { x: 715, y: 332 },
   'seat8': { x: 581, y: 436 }
};

// Default card positions for each seat
export const CARD_POSITIONS: { [key: string]: { x: number, y: number } } = {
   "player0_card0": { x: 396, y: 321 },
   "player0_card1": { x: 471, y: 316 },
   "player1_card0": { x: 233, y: 368 },
   "player1_card1": { x: 248, y: 360 },
   "player2_card0": { x: 165, y: 297 },
   "player2_card1": { x: 176, y: 307 },
   "player3_card0": { x: 203, y: 219 },
   "player3_card1": { x: 191, y: 207 },
   "player4_card0": { x: 307, y: 182 },
   "player4_card1": { x: 326, y: 177 },
   "player5_card0": { x: 499, y: 157 },
   "player5_card1": { x: 515, y: 165 },
   "player6_card0": { x: 660, y: 194 },
   "player6_card1": { x: 677, y: 200 },
   "player7_card0": { x: 686, y: 307 },
   "player7_card1": { x: 693, y: 311 },
   "player8_card0": { x: 584, y: 370 },
   "player8_card1": { x: 599, y: 359 }
};

// Hard-coded starting positions for bet amounts
export const BET_POSITIONS: { [key: string]: { x: number; y: number } } = {
   'player0_bet': { x: 372, y: 406 },
   'player1_bet': { x: 319, y: 358 },
   'player2_bet': { x: 249, y: 325 },
   'player3_bet': { x: 268, y: 268 },
   'player4_bet': { x: 383, y: 202 },
   'player5_bet': { x: 582, y: 211 },
   'player6_bet': { x: 643, y: 271 },
   'player7_bet': { x: 663, y: 320 },
   'player8_bet': { x: 563, y: 385 }
}

// Offset positions for player status text relative to seat position
export const STATUS_TEXT_OFFSETS: { [key: string]: { x: number; y: number } } = {
   'player0_status': { x: 0, y: 2 },
   'player1_status': { x: 0, y: 3 },
   'player2_status': { x: 0, y: 3 },
   'player3_status': { x: 0, y: 4 },
   'player4_status': { x: 0, y: 4 },
   'player5_status': { x: 0, y: 4 },
   'player6_status': { x: 0, y: 0 },
   'player7_status': { x: 0, y: 0 },
   'player8_status': { x: 0, y: 4 }
}

// Calculate the seat index based on player position
export function calculateRelativeSeatIndex(player: Player, userPlayer: Player): number {
   if (player.isUser) {
      return 0; // USER seat is 0
   }

   const userPositionIndex = POSITIONS_CLOCKWISE_PREFLOP.indexOf(userPlayer.position);
   const playerPositionIndex = POSITIONS_CLOCKWISE_PREFLOP.indexOf(player.position);

   // Calculate relative position (clockwise from user)
   let relativePosition = playerPositionIndex - userPositionIndex;

   // Adjust for circular table
   if (relativePosition < 0) {
      relativePosition += POSITIONS_CLOCKWISE_PREFLOP.length;
   }

   return relativePosition;
}

// Standard positions in clockwise order
export const POSITIONS_CLOCKWISE_PREFLOP: PlayerPosition[] = ['UTG', 'UTG+1', 'UTG+2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB'];

// Map player statuses to colors
export const STATUS_COLORS: Record<string, string> = {
   'active': '#f1e3d3',
   'folded': '#b0413e',
   'raised': '#8eb897',
   'called': '#5c84ad',
   'all-in': '#b77b7b'
};
